import React, {
  createContext,
  useCallback,
  useContext,
  useEffect
} from 'react';
import {
  initialState,
  patientInfoInitialLoad,
  PatientInfoSliceReducer
} from './patientInfoSlice';
import { useReducer } from 'lib/hooks/useReducer';

export const PatientInfoContext = createContext({
  patientInfo: initialState,
  dispatch: (() => !!0) as React.Dispatch<any>,

  // eslint-disable-next-line
  refetch: (() => {})
});

export const usePatientInfoContext = () => useContext(PatientInfoContext);

/**
 * Fetch the legacy PatientInfo data
 *
 * @deprecated Do not use this directly. Use the new data fetching hooks, or use `usePatientInfoContext`
 * @param patientId
 * @returns
 */
export function useGetPatientInfo(patientId: string) {
  const [state, dispatch] = useReducer(PatientInfoSliceReducer, {
    ...initialState
  });

  /**
   * Load or re-load patient data
   */
  const refetch = useCallback(() => {
    dispatch(patientInfoInitialLoad(patientId));
  }, [patientId, dispatch]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { state, dispatch, refetch };
}
